import { keepPreviousData, useQuery } from '@tanstack/react-query'
import getAssignedFarms from '../../services/ruutsApi/v2/farms/getAssignedFarms'
import type { AssignedFarmsQuery } from '../../types/apiModels'
import { queryKeys } from './queryKeys'

export const useAssignedFarms = (query: AssignedFarmsQuery, options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: queryKeys.assignedFarms(query),
    queryFn: ({ signal }) => getAssignedFarms({ query, signal }),
    placeholderData: keepPreviousData,
    enabled: options?.enabled ?? true,
    // The table renders its own inline error and Reintentar; the global snackbar would duplicate it.
    meta: { suppressGlobalError: true },
  })
